import { useSeo } from "../lib/seo/useSeo";

/**
 * Declarative wrapper around useSeo. Render once, as early as possible,
 * inside a top-level page component:
 *   <Seo {...generateStoreSEO(storeId, storeInfo, ratingStats)} />
 */
export function Seo(props) {
  useSeo(props);
  return null;
}

export default Seo;
